import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthLayout } from 'UI/layouts/auth';
import { AppRoutes } from './AppRoutes';
import { DashboardLayout } from 'UI/layouts/dashboard';
import { AdminLoginPage } from 'UI/pages/AdminLogin';
import { PrivacyPolicyPage } from 'UI/pages/PrivacyPolicy';
import { DeleteUserAccountPage } from 'UI/pages/DeleteUserAccount';
import { InstagramContentModerationPage } from 'UI/pages/instagramContentModeration';
import { DashboardPage } from 'UI/pages/Dashboard';
import { CategoriesManagementPage } from 'UI/pages/categoriesManagement';

export function Router(): React.ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path={AppRoutes.Auth.AdminLogin()} element={<AdminLoginPage />} />
          <Route path={AppRoutes.Auth.DeleteUserAccount()} element={<DeleteUserAccountPage />} />
        </Route>

        <Route element={<DashboardLayout />}>
          <Route path={AppRoutes.Dashboard.Home()} element={<DashboardPage />} />
          <Route
            path={AppRoutes.Dashboard.CategoriesManagement()}
            element={<CategoriesManagementPage />}
          />
          <Route
            path={AppRoutes.Dashboard.InstagramContentModeration()}
            element={<InstagramContentModerationPage />}
          />
        </Route>

        <Route path={AppRoutes.PrivacyPolicy()} element={<PrivacyPolicyPage />} />
      </Routes>
    </BrowserRouter>
  );
}
